import React from 'react';

import NotFound from 'wanderu-component-not-found';

function DeletedRoute() {
    return <NotFound status={410} />;
}

export default DeletedRoute;
